import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { registerAdmin } from "../../../api/customer";
import { setIsOnPremise } from "../../../state/slices/customer";
import Loader from "../../common/Loader/Loader";

function Check() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [res, setRes] = useState(undefined);
  const fetchData = async () => {
    try {
    const { data, error } = await registerAdmin();

    // Store isOnPremise in Redux for global access
    if (data && data?.is_on_premise !== undefined) {
      dispatch(setIsOnPremise(data?.is_on_premise));
    } else {
      dispatch(setIsOnPremise(false));
    }

    if (data && data.is_on_premise) {
      if (data.show_register_page) {
        setRes(true);
        navigate("register");
      } else {
        setRes(false);
        navigate("login");
      }
    } else {
        if (window.location.pathname.includes("/register") && data?.show_register_page) {
          setRes(true);
        navigate("register");
      } else {
          setRes(false);
        navigate("login");
        }
      }
    } catch (err) {
      console.error("Error in Check component:", err);
      // Default to login page if there's an error
      setRes(false);
      navigate("login");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {}, [res]);
  if (res === undefined) {
    return (
      <>
        <Loader loading={true} bg_papper={false} />
      </>
    );
  } else {
    return (
      <div>
        <Outlet />
      </div>
    );
  }
}
export default Check;
